import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import ProfileImageWrapper from '../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/profileImage';
import generateObjectURL from '../../../../../../../../utility/action-images/getBlob/generateObjectURL';
import Actions from '../../../../../../../../store/actions';
import getToken from '../../../../../../../../utility/getToken';
import GetPresignURL from '../../../../../../../../utility/getPresignURLController';
import getFileKey from '../../../../../../../../utility/getFileKey';
// import { EditWrapper } from '../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/personalInfo';
import getBlobURL from '../../../../../../../../utility/action-images/getBlob/getBlobURL';
import ImageUploadStatus from './imageUploadStatus';
import EditImage from './editImage';
import RenderImage from './renderImage';
import {
  UPADTE_LISTING_BLOBURL,
  UPADTE_LISTING_UNUSED_BLOBURLS,
  UPDATE_LISTING_IMAGE,
  UPADTE_ORG_LISTING_BLOBURL,
  UPADTE_ORG_LISTING_UNUSED_BLOBURLS,
} from '../../../../../../../../store/actions/actionTypes/listings';

import {
  UPDATE_BLOB_URL,
  UPDATE_PROFILE_IMAGE,
  UPDATE_UNUSED_URLS,
} from '../../../../../../../../store/actions/actionTypes/editResumeForm';
import { UPADTE_USER_APPLICATIONS_BLOBURL } from '../../../../../../../../store/actions/actionTypes/userApplications';
import componentType from '../../../../../../../IRIS/utility/componentType';
/**
 * TODO: Use this when comments is introduced
 * 
 const EditorWrapper = styled.div`
   position: absolute;
   top: 0;
   left: 0;
   width: inherit;
   height: inherit;
 `;
 */

class ProfileImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      blobURL: null,
      blobPresent: false,
      isUploading: false,
      imageUploadFailed: false,
      snackBarMessage: null,
    };
  }

  iconSelector = React.createRef();

  componentDidUpdate(prevProps) {
    const { documentPicture, updateUnusedUrls, component, blobURLs } =
      this.props;
    const { documentPicture: prevDocumentPicture } = prevProps;

    const { blobURL, isUploading } = this.state;
    // if (noUpdate) return;

    if (
      documentPicture &&
      Object.keys(documentPicture).length !== 0 &&
      documentPicture !== prevDocumentPicture &&
      blobURL !== documentPicture.blobURL &&
      !isUploading
    ) {
      this.setState({
        blobURL: documentPicture.blobURL,
        blobPresent: true,
      });
      let params = {};

      if (component === componentType.MY_LISTINGS) {
        if (prevProps.documentPicture) {
          if (prevProps.documentPicture.path !== documentPicture.path) {
            params = {
              actionType: UPADTE_LISTING_UNUSED_BLOBURLS,
              payload: {
                blobURLs: {
                  ...blobURLs,
                  [prevProps.documentPicture.path]: false,
                },
              },
            };
            updateUnusedUrls(params);
          }
        }
      }
      if (component === componentType.LISTINGS) {
        if (prevProps.documentPicture) {
          if (prevProps.documentPicture.path !== documentPicture.path) {
            params = {
              actionType: UPADTE_ORG_LISTING_UNUSED_BLOBURLS,
              payload: {
                blobURLs: {
                  ...blobURLs,
                  [prevProps.documentPicture.path]: false,
                },
              },
            };
            updateUnusedUrls(params);
          }
        }
      }
      if (!component) {
        params = {
          payload: {
            unUsedUrl:
              prevProps.documentPicture && prevProps.documentPicture.path,
            currentUrl: documentPicture.path,
          },
          actionType: UPDATE_UNUSED_URLS,
        };
        updateUnusedUrls(params);
      }
    } else if (!documentPicture && blobURL) {
      this.setState({
        blobPresent: 'defaultPicture',
        blobURL: null,
        isUploading: false,
      });
      let params = {};
      if (component === componentType.MY_LISTINGS) {
        params = {
          actionType: UPADTE_LISTING_UNUSED_BLOBURLS,
          payload: {
            blobURLs: {},
          },
        };
      }
      if (component === componentType.LISTINGS) {
        params = {
          actionType: UPADTE_ORG_LISTING_UNUSED_BLOBURLS,
          payload: {
            blobURLs: {},
          },
        };
      }
      if (!component) {
        params = {
          actionType: UPDATE_UNUSED_URLS,
          payload: {
            unUsedUrl:
              prevProps.documentPicture && prevProps.documentPicture.path,
          },
        };
      }

      updateUnusedUrls(params);
    }
  }

  componentDidMount = async () => {
    const { documentPicture, blobURLs, component, orgListings, listingId } =
      this.props;
    if (component === componentType.MY_LISTINGS) {
      let listing;
      // eslint-disable-next-line
      orgListings &&
        orgListings.data &&
        orgListings.data.forEach((orgListing) => {
          if (orgListing.partitionKey === listingId) listing = orgListing;
        });
      if (listing) {
        const { listingLogo } = listing;

        if (listingLogo && listingLogo.blobURL) {
          const { blobURL } = listingLogo;
          this.setState({
            blobURL,
            blobPresent: true,
          });
        } else {
          this.setState({
            blobURL: null,
            blobPresent: 'defaultPicture',
            isUploading: false,
          });
        }
        return;
      }
    }
    if (documentPicture) {
      const { path } = documentPicture || { path: null };
      const isBlobPresent = blobURLs[path];
      await this.setBlobURL(isBlobPresent);
      return;
    }
    this.setDefaultPicture();
  };

  setBlobURL = async (isBlobPresent) => {
    const { documentPicture, updateBlobURL, component, listingId, code } =
      this.props;
    const { path, type } = documentPicture || { path: null };
    if (path) {
      const data = {
        name: path,
        contentType: type,
        methodType: 'getObject',
      };
      if (isBlobPresent) {
        this.setState({
          blobURL: documentPicture.blobURL,
          blobPresent: true,
        });
      } else {
        this.setState({ blobURL: null, blobPresent: false });

        // updateBlobURL({
        //   documentPicture: {
        //     ...documentPicture,
        //     blobURL: null
        //   }
        // });
        const token = await getToken();

        const imageURL = await GetPresignURL.getPresignedURL(data, token);

        const blobURL = await getBlobURL(imageURL, type);

        this.setState({ blobURL, blobPresent: true });

        /**
         * Update blob url in redux for first blob
         */
        let params = {};

        if (component === componentType.MY_LISTINGS) {
          params = {
            actionType: UPADTE_LISTING_BLOBURL,
            payload: {
              listingLogo: {
                ...documentPicture,
                blobURL,
              },
            },
          };
        }
        if (component === componentType.LISTINGS) {
          params = {
            actionType: UPADTE_ORG_LISTING_BLOBURL,
            payload: {
              listingLogo: {
                ...documentPicture,
                blobURL,
              },
              listingId,
            },
          };
        }
        if (component === componentType.ACTIVITY_TAB) {
          params = {
            actionType: UPADTE_USER_APPLICATIONS_BLOBURL,
            payload: {
              listingLogo: {
                ...documentPicture,
                blobURL,
              },
              code,
            },
          };
        }
        if (!component) {
          params = {
            payload: {
              documentPicture: {
                ...documentPicture,
                blobURL,
              },
            },
            actionType: UPDATE_BLOB_URL,
          };
        }

        updateBlobURL(params);
      }
    } else {
      this.setDefaultPicture();
    }
  };

  setDefaultPicture = () => {
    this.setState({
      blobPresent: 'defaultPicture',
    });
  };

  handleOpenDropdown = (e) => {
    e.preventDefault();

    const { show } = this.state;
    this.setState({
      show: !show,
    });
  };

  closeDropDown = () => this.setState({ show: false });

  handleClickOutside = (e) => {
    if (
      this.iconSelector.current &&
      !this.iconSelector.current.contains(e.target)
    ) {
      this.setState({ show: false });
    }
  };

  handleCloseDropdown = (e) => {
    const {
      target: { classList, parentElement },
    } = e;
    const { labelKey } = this.props;
    let parentClassList = '';

    if (parentElement) {
      parentClassList = parentElement.classList;
    }
    /**
     * This is to stop the close drop down,
     * to complete the event triggered for file upload
     *
     * When the user clicks on the text - we need to check parent's(label) classList
     * When the user clicks on the label itself on either side of text - we need to check the element's classList
     */
    const requiredClass = labelKey ? `fileUpload_${labelKey}` : 'fileUpload';

    if (
      classList.contains(requiredClass) ||
      (parentClassList && parentClassList.contains(requiredClass))
    )
      return;

    this.closeDropDown();
  };

  handleRemoveDocumentPicture = async () => {
    const {
      documentPicture,
      updateProfileImage,
      saveDocument,
      setSaveToggler,
      component,
      handleDeleteImage,
      listingId,
    } = this.props;
    if (documentPicture) {
      const { path } = documentPicture;
      if (path) {
        this.setState({
          blobPresent: 'defaultPicture',
          blobURL: null,
          isUploading: false,
        });

        let params = {};

        if (component === componentType.MY_LISTINGS) {
          params = {
            actionType: UPDATE_LISTING_IMAGE,
            payload: {
              listingLogo: null,
              listingId,
            },
          };
        }
        if (!component) {
          params = {
            payload: {
              key: 'documentPicture',
              data: { documentPicture: null },
            },
            actionType: UPDATE_PROFILE_IMAGE,
          };
        }
        await handleDeleteImage();
        updateProfileImage(params);
        setSaveToggler(false);
        setTimeout(saveDocument, 0);
      }
    }
  };

  onChange = async (e) => {
    const { blobURL: prevBlobURL } = this.state;
    const {
      updateProfileImage,
      saveDocument,
      setSaveToggler,
      component,
      setImageUploadPath,
      listingId,
    } = this.props;
    const {
      target: { files },
    } = e;
    const file = files[0];
    const isValidFile = ['image/png', 'image/jpeg'].includes(file.type);

    if (isValidFile) {
      /**
       * When there is no internet connect
       */
      if (!navigator.onLine) {
        this.setState({
          imageUploadFailed: true,
          snackBarMessage: 'Failed to upload. Please check connection',
        });
        return;
      }
      try {
        /**
         * Generate a blob
         */
        const blobURL = generateObjectURL(file);
        this.setState({ blobURL, isUploading: true, blobPresent: true });

        /**
         * Generate a key
         */
        const path = await setImageUploadPath(file);
        /**
         * Upload to s3
         */
        const token = await getToken();

        // Getting file path for uploading the image
        const filePath = `${`${await getFileKey('private')}/${path}`}`;

        const data = {
          name: filePath,
          contentType: file.type,
          methodType: 'putObject',
        };
        const preSignedURL = await GetPresignURL.getPresignedURL(data, token);
        const isUploaded = await GetPresignURL.uploadDataToS3(
          preSignedURL,
          file,
        );
        if (isUploaded) {
          this.setState({
            isUploading: false,
            blobPresent: true,
          });

          let params = {};

          if (component === componentType.MY_LISTINGS) {
            params = {
              payload: {
                listingLogo: { path: filePath, type: file.type, blobURL },
                listingId,
              },
              actionType: UPDATE_LISTING_IMAGE,
            };
          } else {
            params = {
              actionType: UPDATE_PROFILE_IMAGE,
              payload: {
                key: 'documentPicture',
                data: {
                  documentPicture: { path: filePath, type: file.type, blobURL },
                },
              },
            };
          }

          /**
           * Update the redux with the key
           */

          updateProfileImage(params);
          setSaveToggler(false);
          setTimeout(saveDocument, 0);
        }
      } catch (err) {
        this.setState({
          blobURL: prevBlobURL,
          isUploading: false,
          imageUploadFailed: true,
          snackBarMessage: 'Failed to upload. Please try again later!',
        });
      }
    } else {
      this.setState({
        imageUploadFailed: true,
        snackBarMessage:
          'Apologies, but we can only accept jpg, jpeg, png, and gif files. Please try again',
      });
    }
  };

  /**
   * Allows to upload same image multiple times
   * useful when user uses his local software to modify the image and uploads to wisedoc
   */
  clearEventValue = (e) => {
    e.target.value = '';
    this.closeDropDown();
  };

  handleCloseSnackBar = () => {
    this.setState({
      imageUploadFailed: false,
    });
  };

  render() {
    const { showEditOption, createListing } = this.props;
    const {
      show,
      blobURL,
      blobPresent,
      isUploading,
      imageUploadFailed,
      snackBarMessage,
    } = this.state;
    const { labelKey } = this.props;

    return (
      <>
        <ProfileImageWrapper>
          <ImageUploadStatus
            imageUploadFailed={imageUploadFailed}
            snackBarMessage={snackBarMessage}
            handleCloseSnackBar={this.handleCloseSnackBar}
          />

          {showEditOption && (
            <EditImage
              labelKey={labelKey}
              show={show}
              blobPresent={blobPresent}
              onChange={this.onChange}
              clearEventValue={this.clearEventValue}
              handleOpenDropdown={this.handleOpenDropdown}
              handleCloseDropdown={this.handleCloseDropdown}
              handleRemoveDocumentPicture={this.handleRemoveDocumentPicture}
              dataTestId="document_picture"
              createListing={createListing}
              logo
            />
          )}

          <RenderImage
            blobPresent={blobPresent}
            blobURL={blobURL}
            isUploading={isUploading}
          />
        </ProfileImageWrapper>
      </>
    );
  }
}

ProfileImage.propTypes = {
  documentPicture: propTypes.objectOf(propTypes.string),
  updateProfileImage: propTypes.func.isRequired,
  updateBlobURL: propTypes.func.isRequired,
  blobURLs: propTypes.objectOf(propTypes.bool).isRequired,
  setSaveToggler: propTypes.func,
  saveDocument: propTypes.func,
  handleDeleteImage: propTypes.func,
  showEditOption: propTypes.bool,
};

ProfileImage.defaultProps = {
  documentPicture: null,
  setSaveToggler: () => {},
  saveDocument: () => {},
  handleDeleteImage: () => {},
  showEditOption: true,
};

const mapStateToProps = (state, ownProps) => {
  const { component } = ownProps;
  if (component === componentType.MY_LISTINGS) {
    return {
      blobURLs: state.listingsReducer.listing.blobURLs,
      orgListings: state.listingsReducer.orgListings,
    };
  }
  if (component === componentType.LISTINGS) {
    return {
      blobURLs: state.listingsReducer.orgListings.blobURLs,
    };
  }
  if (component === componentType.ACTIVITY_TAB) {
    return {
      blobURLs: state.userApplicationsReducer.blobURLs,
    };
  }
  return {
    documentPicture: state.editResumeFormReducer.documentPicture,
    imageKey: state.editResumeFormReducer.imageKey,
    blobURLs: state.editResumeFormReducer.blobURLs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateProfileImage: (params) =>
      dispatch(Actions.commonActions.updateProfileImage(params)),
    updateBlobURL: (params) =>
      dispatch(Actions.commonActions.updateBlobURL(params)),
    updateUnusedUrls: (params) =>
      dispatch(Actions.commonActions.updateUnusedUrls(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileImage);
